import React from 'react';
import Item from './Item';
import styles from './listInfo.module.scss';



export function InfoList(props) {
  const { list, title } = props;

  return (
    <div className={styles['container']}>
      {list.length ? <h2 className={styles['section-title']}>{title}</h2> : ''}
      <ul className={styles['info-list']}>
        {list.map((item) => {
          return <Item data={item} />;
        })}
      </ul>
    </div>
  );
}

export default InfoList;
